import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

import { StoreState } from "../redux/configure-store";
import DashboardEarningsStats from "./DashboardEarningsStats";
import DashboardEngagements from "./DashboardEngagements";
import InvoicesList from "../common/components/InvoicesList";
import { fetchEngagements, fetchInvoices } from "../user/user-actions";
import { navigateToEngagementsViewPage } from "../routing/route-actions";
import Snackbar from "../common/components/snackbar";
import { backgrounds } from "../theme/theme";

function DashboardPage(props: any) {
  const {
    engagements,
    invoices,
    user,
    isShowSuccessSnackbar,
    fetchEngagements: _fetchEngagements,
    fetchInvoices: _fetchInvoices,
  } = props;

  const [isSuccessSnackbarOpen, setIsSuccessSnackbarOpen] = useState(false);

  const handleSuccessSnackbarClose = (
    event: React.SyntheticEvent | Event,
    reason?: string
  ) => {
    if (reason === "clickaway") {
      return;
    }
    setIsSuccessSnackbarOpen(false);
  };

  useEffect(() => {
    setIsSuccessSnackbarOpen(isShowSuccessSnackbar);
  }, [isShowSuccessSnackbar]);

  useEffect(() => {
    _fetchEngagements();
    _fetchInvoices();
  }, [_fetchInvoices, _fetchEngagements]);

  return (
    <Box
      sx={{
        minHeight: "100vh",
        backgroundColor: backgrounds.page,
        py: 4,
        px: { xs: 2, md: 3 },
      }}
    >
      <Box sx={{ maxWidth: 1400, mx: "auto" }}>
        {/* Header */}
        <Box sx={{ mb: 4 }}>
          <Typography variant="h4" fontWeight={600} gutterBottom>
            Dashboard
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Welcome back{user?.firstName ? `, ${user.firstName}` : ""}! Here's
            an overview of your activity.
          </Typography>
        </Box>

        <Grid container spacing={3}>
          {/* Left Column - Earnings & Invoices */}
          <Grid item xs={12} lg={6}>
            <DashboardEarningsStats
              engagements={engagements}
              invoices={invoices}
              user={user}
            />
            <Box sx={{ mt: 3 }}>
              <InvoicesList invoices={invoices} />
            </Box>
          </Grid>

          {/* Right Column - Engagements */}
          <Grid item xs={12} lg={6}>
            <DashboardEngagements
              engagements={engagements}
              onEngagementClick={(publicId: string) =>
                props.navigateToEngagementsViewPage(publicId)
              }
            />
          </Grid>
        </Grid>
      </Box>

      <Snackbar
        severity="success"
        handleClose={handleSuccessSnackbarClose}
        alertMessage="Success"
        isOpen={isSuccessSnackbarOpen}
      />
    </Box>
  );
}

const mapStateToProps = (storeState: StoreState) => ({
  engagements: storeState.user.engagements,
  invoices: storeState.user.invoices,
  user: storeState.authentication.user,
  isShowSuccessSnackbar: storeState.user.isShowSuccessSnackbar,
});

export default connect(mapStateToProps, {
  fetchEngagements,
  fetchInvoices,
  navigateToEngagementsViewPage,
})(DashboardPage);
